import { render } from "./ZNclasswide.vue?vue&type=template&id=20608532&scoped=true"
import script from "./ZNclasswide.vue?vue&type=script&lang=js"
export * from "./ZNclasswide.vue?vue&type=script&lang=js"

import "./ZNclasswide.vue?vue&type=style&index=0&id=20608532&lang=scss&scoped=true"
import "./ZNclasswide.vue?vue&type=style&index=1&id=20608532&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20608532"]])

export default __exports__